/**
 * BKF How to Clean carousel — aligns with Figma (Bar Keeper's Friend Web, nodes 596:1172 / 2023:29).
 * "Great for" pill labels are sourced from product metafield custom.great_for in Liquid (see
 * snippets/bkf-product-great-for-tags.liquid); this script syncs slide JSON into the UI.
 */
(function () {
  function esc(value) {
    if (value == null) return '';
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function normalizeTags(rawTags) {
    if (Array.isArray(rawTags)) {
      return rawTags
        .map(function (tag) {
          return tag == null ? '' : String(tag).trim();
        })
        .filter(Boolean);
    }

    if (typeof rawTags === 'string') {
      return rawTags
        .split(',')
        .map(function (tag) {
          return tag.trim();
        })
        .filter(Boolean);
    }

    return [];
  }

  function placeholderMarkup() {
    return (
      '<div class="bkf-how-to-clean-carousel__placeholder">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5" aria-hidden="true">' +
      '<path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1v92.5z"/>' +
      '<path d="M210.4 299.5H240v.1s.1 0 .2-.1h21.6s0 .1.1.1h21.4v-57.8h-72.9v57.7zm2.2-55.6h68.4v42.2l-23.5-22.1c-.6-.5-1.5-.6-2.1-.1l-21.7 18.2-7.3-6.4c-.6-.5-1.5-.6-2.1-.1l-11.7 10v-41.7z"/>' +
      '<path d="M261.9 261.3c2.9 0 5.3-2.4 5.3-5.3s-2.4-5.3-5.3-5.3-5.3 2.4-5.3 5.3 2.4 5.3 5.3 5.3zm0-8.9c2 0 3.6 1.6 3.6 3.6s-1.6 3.6-3.6 3.6-3.6-1.6-3.6-3.6 1.6-3.6 3.6-3.6z"/>' +
      '</svg>' +
      '</div>'
    );
  }

  function createSlideMarkup(slide) {
    var badgeMarkup = slide.badgeText
      ? '<span class="bkf-how-to-clean-carousel__badge">' + esc(slide.badgeText) + '</span>'
      : '';
    var overlayMarkup = slide.overlayImage
      ? '<img src="' +
        esc(slide.overlayImage) +
        '" alt="" class="bkf-how-to-clean-carousel__overlay-image" loading="lazy" decoding="async" aria-hidden="true" />'
      : '';
    var mediaMarkup = slide.image
      ? '<img src="' +
        esc(slide.image) +
        '" alt="' +
        esc(slide.alt || slide.title || '') +
        '" class="bkf-how-to-clean-carousel__slide-image" loading="lazy" decoding="async" />'
      : placeholderMarkup();

    return (
      '<div class="bkf-how-to-clean-carousel__item" style="left: 50%; transform: translateX(-50%) translateY(0px); opacity: 0; pointer-events: none;">' +
      '<div class="bkf-how-to-clean-carousel__card">' +
      badgeMarkup +
      '<a class="bkf-how-to-clean-carousel__media" data-bkf-how-to-clean-product-link href="' +
      esc(slide.url || '#') +
      '" aria-label="View ' +
      esc(slide.title || 'product') +
      '" tabindex="-1">' +
      mediaMarkup +
      overlayMarkup +
      '</a>' +
      '</div>' +
      '</div>'
    );
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  var BKF_STAR_PATH = 'M18.9652 0L23.4423 13.7792L37.9304 13.7792L26.2093 22.2951L30.6863 36.0742L18.9652 27.5583L7.24407 36.0742L11.7211 22.2951L0 13.7792L14.4881 13.7792L18.9652 0Z';
  var BKF_STAR_VB = '0 0 37.9304 36.0742';
  var BKF_STAR_CLIP_W = 18.9652;
  var BKF_STAR_CLIP_H = 36.0742;
  var starClipIdSeed = 0;

  function renderStars(ratingX10) {
    var normalizedRating = Number(ratingX10);
    if (!isFinite(normalizedRating)) normalizedRating = 0;
    if (normalizedRating < 0) normalizedRating = 0;
    if (normalizedRating > 50) normalizedRating = 50;

    var stars = '';
    var clipPrefix = 'bkf-htc-star-' + (starClipIdSeed += 1);

    for (var i = 1; i <= 5; i += 1) {
      var fullThreshold = i * 10;
      var halfThreshold = fullThreshold - 5;
      if (normalizedRating >= fullThreshold) {
        stars +=
          '<svg class="bkf-how-to-clean-carousel__star" viewBox="' + BKF_STAR_VB + '" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="' + BKF_STAR_PATH + '" fill="currentColor"/>' +
          '</svg>';
      } else if (normalizedRating >= halfThreshold) {
        var clipId = clipPrefix + '-' + i;
        stars +=
          '<svg class="bkf-how-to-clean-carousel__star" viewBox="' + BKF_STAR_VB + '" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">' +
          '<defs><clipPath id="' + clipId + '"><rect x="0" y="0" width="' + BKF_STAR_CLIP_W + '" height="' + BKF_STAR_CLIP_H + '"/></clipPath></defs>' +
          '<path d="' + BKF_STAR_PATH + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"/>' +
          '<path d="' + BKF_STAR_PATH + '" fill="currentColor" clip-path="url(#' + clipId + ')"/>' +
          '</svg>';
      } else {
        stars +=
          '<svg class="bkf-how-to-clean-carousel__star" fill="none" viewBox="' + BKF_STAR_VB + '" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="' + BKF_STAR_PATH + '" stroke="currentColor" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"/>' +
          '</svg>';
      }
    }

    return stars;
  }

  function mount(root, config) {
    var sectionId = config.sectionId;
    var slides = config.slides || [];
    var track = document.getElementById('bkf-how-to-clean-track-' + sectionId);
    var titleEl = document.getElementById('bkf-how-to-clean-title-' + sectionId);
    var reviewsEl = document.getElementById('bkf-how-to-clean-reviews-' + sectionId);
    var reviewTextEl = reviewsEl ? reviewsEl.querySelector('.bkf-how-to-clean-carousel__review-text') : null;
    var reviewStarsEl = reviewsEl ? reviewsEl.querySelector('.bkf-how-to-clean-carousel__stars') : null;
    var tagsRowEl = document.getElementById('bkf-how-to-clean-tags-row-' + sectionId);
    var tagsEl = document.getElementById('bkf-how-to-clean-tags-' + sectionId);
    var descriptionEl = document.getElementById('bkf-how-to-clean-description-' + sectionId);
    var ctaEl = document.getElementById('bkf-how-to-clean-cta-' + sectionId);
    var prevBtn = document.getElementById('bkf-how-to-clean-prev-' + sectionId);
    var nextBtn = document.getElementById('bkf-how-to-clean-next-' + sectionId);
    var fadeTargets = root.querySelectorAll('.bkf-how-to-clean-carousel__fade-target');

    if (!track || !titleEl || !reviewTextEl || !reviewStarsEl || !descriptionEl || !ctaEl || !tagsEl || !tagsRowEl) return;

    if (!slides.length) {
      if (prevBtn) prevBtn.disabled = true;
      if (nextBtn) nextBtn.disabled = true;
      return;
    }

    var currentIndex = 0;
    var prevOffsets = [];
    var startX = 0;
    var isDragging = false;
    var fadeTimer = null;

    function toggleButtons() {
      var disableNav = slides.length <= 1;
      if (prevBtn) prevBtn.disabled = disableNav;
      if (nextBtn) nextBtn.disabled = disableNav;
    }

    function setCta(slide) {
      var label = (slide && slide.ctaLabel) || config.defaultCtaLabel || 'Shop Now';
      var url = (slide && slide.url) || '';

      ctaEl.textContent = label;
      if (url) {
        ctaEl.href = url;
        ctaEl.removeAttribute('aria-disabled');
        ctaEl.removeAttribute('data-bkf-how-to-clean-empty-cta');
      } else {
        ctaEl.href = '#';
        ctaEl.setAttribute('aria-disabled', 'true');
        ctaEl.setAttribute('data-bkf-how-to-clean-empty-cta', '');
      }
    }

    function setTags(slide) {
      var tags = normalizeTags(slide && slide.tags);
      if (!tags.length) {
        tagsEl.innerHTML = '';
        tagsRowEl.classList.add('hidden');
        return;
      }

      tagsEl.innerHTML = tags
        .map(function (tag) {
          return (
            '<span class="bkf-how-to-clean-carousel__tag" role="listitem">' + esc(tag) + '</span>'
          );
        })
        .join('');
      tagsRowEl.classList.remove('hidden');
    }

    function setDescription(slide) {
      var description = (slide && slide.description) || '';
      if (!description) {
        descriptionEl.innerHTML = '';
        descriptionEl.classList.add('hidden');
        return;
      }

      descriptionEl.innerHTML = esc(description).replace(/\n/g, '<br>');
      descriptionEl.classList.remove('hidden');
    }

    function updateContent(animate) {
      var activeSlide = slides[currentIndex];
      var doAnimate = animate && !prefersReducedMotion();

      window.clearTimeout(fadeTimer);

      if (doAnimate) {
        fadeTargets.forEach(function (node) {
          node.classList.add('is-fading');
        });
      }

      fadeTimer = window.setTimeout(
        function () {
          titleEl.textContent = activeSlide.title || config.emptyStateTitle || '';
          reviewTextEl.textContent = activeSlide.reviewText || '0 REVIEWS';
          reviewStarsEl.innerHTML = renderStars(activeSlide.ratingX10);
          if (reviewsEl) {
            reviewsEl.setAttribute('aria-label', activeSlide.ratingLabel || '0 out of 5 stars, 0 REVIEWS');
          }
          setTags(activeSlide);
          setDescription(activeSlide);
          setCta(activeSlide);

          fadeTargets.forEach(function (node) {
            node.classList.remove('is-fading');
          });
        },
        doAnimate ? 180 : 0
      );
    }

    function updateCarousel() {
      var itemEls = track.querySelectorAll('.bkf-how-to-clean-carousel__item');
      var isMobile = window.innerWidth < 768;
      var numItems = slides.length;

      itemEls.forEach(function (el, index) {
        var offset = ((index - currentIndex) % numItems + numItems) % numItems;
        var slide = slides[index];
        if (offset > Math.floor(numItems / 2)) {
          offset -= numItems;
        }

        var style = { left: '50%', scale: 0.5, z: 0, op: 0, y: 0 };

        if (offset === 0) {
          style = { left: '50%', scale: isMobile ? 1.05 : 1.35, z: 40, op: 1, y: 0 };
        } else if (offset === -1) {
          style = {
            left: isMobile ? '25%' : '33.4%',
            scale: isMobile ? 0.82 : 1,
            z: 30,
            op: isMobile ? 0.65 : 1,
            y: 0,
          };
        } else if (offset === 1) {
          style = {
            left: isMobile ? '75%' : '66.6%',
            scale: isMobile ? 0.82 : 1,
            z: 30,
            op: isMobile ? 0.65 : 1,
            y: 0,
          };
        } else if (offset === -2) {
          style = {
            left: isMobile ? '-8%' : '16.5%',
            scale: isMobile ? 0.68 : 1,
            z: 10,
            op: isMobile ? 0.16 : 1,
            y: 0,
          };
        } else if (offset === 2) {
          style = {
            left: isMobile ? '108%' : '83.5%',
            scale: isMobile ? 0.68 : 1,
            z: 10,
            op: isMobile ? 0.16 : 1,
            y: 0,
          };
        } else if (offset < -2) {
          style = { left: isMobile ? '-32%' : '0%', scale: isMobile ? 0.64 : 1, z: 0, op: 0, y: 0 };
        } else if (offset > 2) {
          style = { left: isMobile ? '132%' : '100%', scale: isMobile ? 0.64 : 1, z: 0, op: 0, y: 0 };
        }

        var prevOffset = prevOffsets[index];
        if (prevOffset !== undefined) {
          if ((prevOffset >= 2 && offset <= -2) || (prevOffset <= -2 && offset >= 2)) {
            el.style.transition = 'none';
            el.style.left = style.left;
            el.style.transform =
              'translateX(-50%) translateY(' + style.y + 'px) scale(' + style.scale + ')';
            el.style.zIndex = String(style.z);
            el.style.opacity = String(style.op);
            void el.offsetWidth;
            el.style.transition = '';
          }
        }

        el.style.left = style.left;
        el.style.transform =
          'translateX(-50%) translateY(' + style.y + 'px) scale(' + style.scale + ')';
        el.style.zIndex = String(style.z);
        el.style.opacity = String(style.op);
        el.style.pointerEvents = style.op > 0.12 ? 'auto' : 'none';
        el.setAttribute('aria-hidden', offset === 0 ? 'false' : 'true');
        var mediaLink = el.querySelector('[data-bkf-how-to-clean-product-link]');
        var isActiveSlide = offset === 0 && style.op > 0.12;
        if (mediaLink) {
          mediaLink.href = (slide && slide.url) || '#';
          mediaLink.setAttribute(
            'aria-label',
            'View ' + ((slide && slide.title) || 'product')
          );
          mediaLink.tabIndex = isActiveSlide && slide && slide.url ? 0 : -1;
          mediaLink.style.pointerEvents = isActiveSlide ? 'auto' : 'none';
          if (slide && slide.url) {
            mediaLink.removeAttribute('aria-disabled');
          } else {
            mediaLink.setAttribute('aria-disabled', 'true');
          }
        }

        el.onclick = function () {
          if (offset !== 0 && !isDragging) {
            currentIndex = (currentIndex + offset + numItems) % numItems;
            updateCarousel();
            updateContent(true);
          }
        };

        prevOffsets[index] = offset;
      });
    }

    function moveNext() {
      if (slides.length <= 1) return;
      currentIndex = (currentIndex + 1) % slides.length;
      updateCarousel();
      updateContent(true);
    }

    function movePrev() {
      if (slides.length <= 1) return;
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;
      updateCarousel();
      updateContent(true);
    }

    function handleSwipe(diff) {
      if (Math.abs(diff) < 45) return;
      if (diff > 0) moveNext();
      else movePrev();
    }

    function setupEventListeners() {
      if (nextBtn) nextBtn.addEventListener('click', moveNext);
      if (prevBtn) prevBtn.addEventListener('click', movePrev);
      track.querySelectorAll('[data-bkf-how-to-clean-product-link]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          if (link.getAttribute('href') === '#') event.preventDefault();
        });
      });

      window.addEventListener('resize', updateCarousel);

      track.addEventListener(
        'touchstart',
        function (event) {
          startX = event.touches[0].clientX;
          isDragging = false;
        },
        { passive: true }
      );

      track.addEventListener(
        'touchmove',
        function () {
          isDragging = true;
        },
        { passive: true }
      );

      track.addEventListener('touchend', function (event) {
        if (!isDragging) return;
        handleSwipe(startX - event.changedTouches[0].clientX);
        window.setTimeout(function () {
          isDragging = false;
        }, 50);
      });

      track.addEventListener('mousedown', function (event) {
        startX = event.clientX;
        isDragging = false;
      });

      track.addEventListener('mousemove', function (event) {
        if (event.buttons === 1) isDragging = true;
      });

      track.addEventListener('mouseup', function (event) {
        if (!isDragging) return;
        handleSwipe(startX - event.clientX);
        window.setTimeout(function () {
          isDragging = false;
        }, 50);
      });

      track.addEventListener('mouseleave', function () {
        isDragging = false;
      });

      ctaEl.addEventListener('click', function (event) {
        if (ctaEl.getAttribute('href') === '#') event.preventDefault();
      });
    }

    track.innerHTML = slides.map(createSlideMarkup).join('');
    toggleButtons();
    updateCarousel();
    updateContent(false);
    setupEventListeners();
  }

  function mountAll() {
    document
      .querySelectorAll('[data-bkf-how-to-clean-carousel]:not([data-bkf-how-to-clean-mounted])')
      .forEach(function (root) {
        var configNode = root.querySelector('.bkf-how-to-clean-carousel__config[type="application/json"]');
        if (!configNode) return;

        try {
          var config = JSON.parse(configNode.textContent);
          root.setAttribute('data-bkf-how-to-clean-mounted', '');
          mount(root, config);
        } catch (error) {
          console.warn('BKF How to Clean Carousel: invalid config', error);
        }
      });
  }

  function run() {
    mountAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function () {
    mountAll();
  });
})();
